import isBrowser from '../isBrowser'

//@ts-ignore
export const gtagEnabled = () => isBrowser && typeof window.gtag === 'function'
